import Roof from './roof.js'
let text = window.text; // We depend on global localization


  let angleToHeight = function(repetitionWidth, angle){
    return repetitionWidth*Math.tan(angle/180*Math.PI);
  }

  let angle = function(height, repetitionWidth){
    return Math.atan2(height, repetitionWidth);
  }

  let repetitionWidth = function(width, repetitions){
    return width/repetitions;
  }

export default class SawtoothRoof extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width", // Width of one repetition
        title: text.width
      },
      {
        name: "height",
        title: text.height,
        alternatives:{
          names: ["angle"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "height"){
              return height;
            }
            // Note> multiplication with 1000 on num repetitions required since conversion to mm converts all to with 10000
            return Roof.angle(height,repetitionWidth(values["width"], values["repetitions"]*1000)*2)*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "height"){
              return propertyValue;
            }
            let angle = propertyValue * Roof.degreeToRadian;
            return Roof.angleToHeight(repetitionWidth(values["width"], values["repetitions"]*1000)*2, angle);
          },
        },
      },
      {
        name: "repetitions",
        title: text.repetitions
      },
    ]

    this.name = text.rSawtooth
    this.description = text.rdSawtooth
  }

	pipes() {
		let i = this.props
		let d = [i.length];
		for(let i = 0; i < i.repetitions; i++) {
			d.push(i.length)
		}
		return d
  }
  
  vindski() {
    let p = this.props;
    let vert = Math.max(0.0, this.props.height*(p.repetitions-1));
    let diag = p.repetitions * this.repetitionWidth()/Math.cos(angle(p.height, this.repetitionWidth()));
    return vert + diag;
  }

  mone() {
    return Math.max(0.0,this.props.length * (this.props.repetitions-1));
  }


  // The width of one repetition of the sawtooth roof
  repetitionWidth(){
    return repetitionWidth(this.props.width, this.props.repetitions);
  }

  fullWidth(){
    return 1000*this.props.width;
  }

  height(){
    return this.props.height*1000
  }

  topatches() {
    let patches = [];
    for(let i = 0; i < this.props.repetitions-1; i++){
      patches.push(
        this.fromrect(
          1000*this.props.length,
          1000*this.repetitionWidth()/Math.cos(angle(this.props.height, this.repetitionWidth())),
        ));
      patches.push(
        this.fromrect(
          1000*this.props.length,
          this.height(),
        ));
    }
    if ( this.props.repetitions > 0){
      patches.push(
        this.fromrect(
          1000*this.props.length,
          1000*this.repetitionWidth()/Math.cos(angle(this.props.height, this.repetitionWidth())),
        ));
    }
    return patches;
  }

  patchtransforms() {
    let off = (this.fullWidth()) / 20

    let transforms = [];
    let cum = 0
    for(let i = 0; i < this.props.repetitions-1; i++){
      let pieceWidth = -1000*this.repetitionWidth()/Math.cos(angle(this.props.height, this.repetitionWidth()))
      transforms.push(
        {
          t: [-this.props.length/2*1000,pieceWidth+cum - off],
          r: [0, 0, 0],
        });
      cum += pieceWidth - off/2

      pieceWidth = -this.height()
      transforms.push(
        {
          t: [-this.props.length/2*1000,pieceWidth+cum - off],
          r: [0, 0, 0],
        })
      cum += pieceWidth - off
    }
    if ( this.props.repetitions > 0){
      let pieceWidth = -1000*this.repetitionWidth()/Math.cos(angle(this.props.height, this.repetitionWidth()));
      transforms.push(
          {
            t: [-this.props.length/2*1000,pieceWidth+cum - off],
            r: [0, 0, 0],
          });
        return transforms;
    }
  }
  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./roofs/sawtoothroof.js